var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.5412 3.75H5.5C4.25736 3.75 3.25 4.75736 3.25 6V19C3.25 20.2426 4.25736 21.25 5.5 21.25H18.5C19.7426 21.25 20.75 20.2426 20.75 19V8.95825L17.3896 12.3187C16.7848 12.9234 15.9916 13.3033 15.1413 13.3953L13.3944 13.5843C12.7171 13.6576 12.0431 13.42 11.5614 12.9383C11.0797 12.4566 10.8421 11.7826 10.9154 11.1053L11.1044 9.35838C11.1964 8.50813 11.5763 7.71486 12.181 7.11014L15.5412 3.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8748 3.01256C20.1914 2.32914 19.0833 2.32915 18.3999 3.01256L17.7143 3.69812L20.8016 6.78534L21.4871 6.09978C22.1705 5.41637 22.1705 4.30833 21.4871 3.62491L20.8748 3.01256Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7409 7.846L16.6537 4.75878L13.2417 8.1708C12.8788 8.53363 12.6509 9.00959 12.5957 9.51974L12.4067 11.2667C12.3823 11.4924 12.4614 11.7171 12.622 11.8777C12.7826 12.0382 13.0073 12.1174 13.233 12.093L14.9799 11.904C15.4901 11.8488 15.9661 11.6209 16.3289 11.258L19.7409 7.846Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoPen);
export default __webpack_public_path__ + "static/media/DuoPen.40e44de2f4d6442cf52af1b5b6c3afaf.svg";
export { ForwardRef as ReactComponent };